/*
 * @Author: tangke
 * @Date: 2019-02-16 17:57:17
 * @Last Modified by: others
 * @Last Modified time: 2019-03-02 10:38:53
 * 导航栏个人信息面板下Flowers For Cash的弹窗
 */
 <template>
  <v-dialog v-model="cashData.dialog"
            width="600">
    <v-card>
      <v-card-title class="title blue-title pa-3 pt-4 ml-2">
        Convert for Cash
        <div class="header-close" title="close" @click="cashData.dialog = false"><v-icon>close</v-icon></div>
      </v-card-title>

      <v-card-title class="pt-0">
        <div class="px-2">
          <p class="blue-title-2 font-weight-black mb-0"><span class="font-24">{{ flowerAmount }}</span>&nbsp;Remaining Flower Converted Quota</p>
          <p class="mb-0 flower-tips"> 1 Flower = 5 PHP, only 100 flowers can be exchanged per month.</p>
        </div>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-form v-model="valid" ref="form">
          <v-container class="pt-0">
              <v-layout row>
                <v-flex xs12 pl-0>
                  　<ul class="btn-numbox pl-0">
                      <li>
                          <ul class="count">
                              <li @click="reduce"><span id="num-jian" class="num-jian">-</span></li>
                              <li><input type="text" class="input-num" id="input-num" value="0" v-model="flowersCount" :rules="[rules.required]"/></li>
                              <li @click="add"><span id="num-jia" class="num-jia">+</span></li>
                          </ul>
                      </li>
                      <li><span class="kucun">NO. of Flower(s)</span></li>
          　　　    </ul>
                    <span class="red--text pl-1" style="font-size:12px">{{countErrors}}</span>
                </v-flex>
              </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-flex xs4>
                  <v-subheader class="pa-0 form-title">Remark</v-subheader>
                </v-flex>
                <v-textarea outline
                            no-resize
                            v-model="remark"
                            counter="200"
                            :rules="[rules.required, rules.remark]"
                            >
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="py-4">
        <v-layout justify-center>
          <v-btn class="text-none red-button dialog-submit"
               @click="submit">Transfer cash</v-btn>
          <v-btn class="text-none cancel-button"
               @click="cashData.dialog = false">Cancel</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { exchangeCash } from '@/api/teachinfo'
import { getLastFlowerAmount } from '@/api/user'

export default {
  name: 'covertCash',
  props: {
    cashData: {
      dialog: false
    }
  },
  data: () => ({
    valid: false,
    flowersCount: 0,
    remark: '',
    flowerAmount: 0,
    rules: {
      required: value => !!value || 'Required.',
      remark: v => (v && v.length <= 200) || 'Remark must be less than 200 characters'
    },
    countErrors: ''
  }),
  mounted(){
    this.flowersCount=0;
  },
  methods: {
    reduce(){
      if(this.flowersCount>0)
      this.flowersCount--;
    },
    add(){
      if(this.flowersCount<this.flowerAmount)
      this.flowersCount++;
    },
    submit () {
      if (!this.$refs.form.validate() || this.countErrors != '') {
        return
      }
      var that = this
      if (that.flowersCount == 0) {
        that.$root.$alertTips('Please re-enter the valid number of flowers')
        return
      }
      exchangeCash(that.flowersCount, that.remark).then(res => {
        let type = res.data.ErrorCode === 0 ? 'success' : 'error'
        that.$root.$alertTips(res.data.Msg, type).then(() => {
          if (res.data.ErrorCode === 0) {
            that.cashData.dialog = false
          }
        })
      })
    }
  },
  watch: {
    'cashData.dialog': function (value) { // 重置表单
      if (value) {
        if (this.$refs['form'] !== undefined) {
          this.$refs['form'].reset()
        }
        getLastFlowerAmount().then(res => {
          this.flowerAmount = res
        })
      }
    },
    'flowersCount': function(data){ //鲜花数验证
      if(!data && data != undefined){
        this.countErrors = "Required!"
      }else if(data && data > this.flowerAmount){
        this.countErrors = "Exceeding the quota, please re-enter!"
      }else{
        this.countErrors = ''
      }
    }
  }
}
</script>
<style scoped lang="scss">
.font-24{
  font-size:24px !important;
}
 ul,
            li {
                list-style: none;
            }
  .btn-numbox {
                overflow: hidden;
            }
            
            .btn-numbox li {
                float: left;
            }
            
            .btn-numbox li .number,
            .kucun {
                display: inline-block;
                font-size: 12px;
                @include font_color($font-color-theme);
                vertical-align: sub;
            }
            
            .btn-numbox .count {
                overflow: hidden;
                margin: 0 16px 0 -20px;
            }
            
            .btn-numbox .count .num-jian,
            .input-num,
            .num-jia {
                display: inline-block;
                width: 28px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                font-size: 18px;
                color: #32397A;
                cursor: pointer;
                border: 1px solid #A9AECA;
            }
            .num-jia{
              border-radius: 0px 4px 4px 0px;
              background: rgba(233, 244, 255, 0.3);
            }
            .num-jian{
              border-radius: 4px 0px 0px 4px;
              background: rgba(233, 244, 255, 0.3);
            }
            .btn-numbox .count .input-num {
                width: 58px;
                height: 28px;
                @include font_color($font-color-theme);
                border-left: 0;
                border-right: 0;
            }
  .covert-subtitle{
    font-size: 14px;
    margin-left: 10px;
    padding-top: 3px;
  }
  .covert-total{
    font-size: 20px;
    text-decoration: underline;
    margin-left: 5px;
  }
  .exchanged-only{
    color: #ff5252;
  }
  .flower-tips{
    color: rgba(50, 57, 122, 0.4);
  }
  [data-theme="theme1"] .flower-tips{
    color:#ececec;
  }
</style>
